<div class="content">

  <div class="page-title">
    <h1>Asset Register</h1>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.companyId" [disable]="disableCompany" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.locationId" [disable]="disableLocation" [userLocationIds]="user.locationIds" [companyId]="filter.companyId" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>

        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>Report Type</label>
            <app-category-picker [categoryId]="filter.categoryId" [_placeholder]="'All'" (onCategorySet)="onCategoryChange($event)"></app-category-picker>

          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Status</label>

            <ng-select [items]="completed_Statuses" [ngModelOptions]="{standalone: true}" bindLabel="Name" bindValue="Value" [virtualScroll]="true"
                       placeholder="All" [(ngModel)]="filter.status" [selectOnTab]="true">
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row buffer-bottom">

        <div class="col-md-3 col-sm-6">
          <label>Serial #</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.serial_Num" />
        </div>
        <div class="col-md-3 col-sm-6">
          <label>Plant #</label>
          <input type="text" class="form-control" name="acc" [(ngModel)]="filter.asset_Num" />
        </div>
        <div class="col-md-3 col-sm-6">
          <label>Job #</label>
          <input type="text" class="form-control" name="job" [(ngModel)]="filter.job_No" />
        </div>
        <!--<div class="col-md-3 col-sm-6">
    <label>Contract #</label>
    <input type="text" class="form-control" name="acc" [(ngModel)]="filter.contract_No" />
  </div>-->
      </div>

      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>



  <app-loading-icon *ngIf="loading"></app-loading-icon>


  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                 [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">

    <ngx-datatable-column name="Download">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a *ngIf="!row.missing && row.inspection_Id != null" href="javascript:void(0)" (click)="downloadReport(row.inspection_Id,row.asset_Num)">Download</a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Company" prop="company_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    
    <ngx-datatable-column name="Job Number" prop="job_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Contract " prop="location_Contract_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Category" prop="category_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Description" prop="description">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Serial #" prop="serial_Num">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Plant #" prop="asset_Num">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="passed">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.inspection_Id != null && row.passed && !row.missing">Passed</div>
        <div *ngIf="row.inspection_Id != null && !row.passed && !row.missing">Failed</div>
        <div *ngIf="row.inspection_Id != null && row.missing">Not Located</div>
        <div *ngIf="row.inspection_Id == null">Not Inspected</div>
      </ng-template>
    </ngx-datatable-column>


  </ngx-datatable>
</div>
